import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [message, setMessage] = useState('Verifying your email...');
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      setMessage('Invalid verification link');
      return;
    }

    const verify = async () => {
      try {
        await api.post('/api/auth/verify-email', { token });
        setMessage('Email verified successfully! Redirecting...');
        setTimeout(() => navigate('/login'), 2000);
      } catch (err: any) {
        setMessage(err.response?.data?.message || 'Verification failed');
      }
    };

    verify();
  }, [token, navigate]);

  return (
    <div className="page-shell flex items-center justify-center px-4 py-12">
      <div className="ui-card max-w-md p-12 text-center">
        <h1 className="mb-6 text-3xl font-extrabold text-secondary">Email Verification</h1>
        <p className="text-lg text-textMuted leading-relaxed">{message}</p>
      </div>
    </div>
  );
}